import { render, staticRenderFns } from "./add-tables-to-view.component.vue?vue&type=template&id=3fb87aa2&"
import script from "./add-tables-to-view.component.vue?vue&type=script&lang=js&"
export * from "./add-tables-to-view.component.vue?vue&type=script&lang=js&"
import style0 from "./add-tables-to-view.component.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports